import { connect } from 'react-redux'

import { itemsSelector } from '@/checkout-instore-legacy/cart/selectors'

import OrderFormPrice from './OrderFormPrice'
import { shippingWasFilledSelector } from '@/checkout-instore-legacy/metadata/selectors'

const mapStateToProps = (state: any) => {
  return {
    order: state.order,
    items: itemsSelector(state),
    shippingWasFilled: shippingWasFilledSelector(state),
  }
}

export default connect(mapStateToProps, undefined)(OrderFormPrice)
